import { CarouselDate } from './props'
import { ReactElement } from 'react'
import { Button, SVG, SVGs, Text } from '../..'
import { StyledCarouselItem } from './styles'

class Mapper {
    public static CarouselItem(
        { date, dayString, shortDate, state }: CarouselDate,
        onClick: (date: string) => void,
        showCloseIcon: boolean
    ): ReactElement {
        return (
            <StyledCarouselItem key={date}>
                <Button
                    active={state === 'selected'}
                    data-cy={`Date_${
                        state === 'disabled' ? 'disabled' : 'enabled'
                    }`}
                    disabled={state === 'disabled'}
                    onClick={() => onClick(date)}
                    variant="option"
                >
                    <Text>{dayString}</Text>
                    <Text size="xl">{shortDate}</Text>
                    {state === 'selected' && showCloseIcon && (
                        <SVG src={SVGs.CloseCircleFilled} />
                    )}
                </Button>
            </StyledCarouselItem>
        )
    }
}

export default Mapper
